import { Link } from "react-router-dom";
import { Shield, ArrowRight } from "lucide-react";

export default function TriagemBanner() {
  return (
    <section
      data-testid="triagem-banner"
      className="bg-gradient-to-r from-ga-emerald via-ga-emerald to-ga-emerald/90 text-white"
    >
      <div className="container-ga py-3 sm:py-3.5">
        <Link
          to="/triagem"
          data-testid="triagem-banner-link"
          className="group flex flex-col sm:flex-row items-start sm:items-center sm:justify-center gap-2 sm:gap-5 text-sm sm:text-[15px]"
        >
          <div className="inline-flex items-center gap-2 shrink-0">
            <div className="w-7 h-7 rounded-full bg-white/15 backdrop-blur-md flex items-center justify-center">
              <Shield className="w-3.5 h-3.5" />
            </div>
            <span className="text-[10px] sm:text-[11px] uppercase tracking-[0.2em] font-bold text-white/80">
              Triagem orientativa · gratuita
            </span>
          </div>
          <div className="flex-1 sm:flex-none font-semibold leading-tight">
            Responda 15 perguntas sobre o desenvolvimento da sua criança
            <span className="hidden sm:inline"> e receba orientação por e-mail.</span>
          </div>
          <span className="ml-auto sm:ml-0 inline-flex items-center gap-1.5 font-bold whitespace-nowrap group-hover:gap-2.5 transition-all">
            Fazer triagem
            <ArrowRight className="w-4 h-4" />
          </span>
        </Link>
      </div>
    </section>
  );
}
